module.exports = __webpack_public_path__ + "7c467b2547f71cd6e922a016666de4a1.svg";